export default {
  default: () => import("/var/www/nature/nature-website/layouts/default.vue").then(m => m.default || m),
  "svg-sprite": () => import("#build/svg-sprite.vue").then(m => m.default || m)
}